<template lang="">
    <div class="">
        Why this error
    </div>
</template>
<script>
import BaseSelected from '@/components/BaseSelected.vue'
import Autocomplete from '@trevoreyre/autocomplete-vue'
export default {
       
        }
</script>
<style lang="">
    
</style>